module.exports = __webpack_public_path__ + "img/Fledermaus.517d634d.jpg";